// import { useDeleteModal } from "@/stores/useDeleteModal"
import { Button } from "@workspace/web-ui/components/button"
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@workspace/web-ui/components/dialog"
import { Input } from "@workspace/web-ui/components/input"
import { cn } from "@workspace/web-ui/lib/utils"
import { AlertCircle, X } from "lucide-react"
import { useState } from "react"
import { useDeleteModal } from "../store/delete-store"
// import { cn } from "@/lib/utils"

interface DeleteAccountProps {
    deleteAccount: () => void;
}

export function DeleteAccountModal({deleteAccount}: DeleteAccountProps) {
  const { isOpen, close } = useDeleteModal()
  const [input, setInput] = useState("")
  const [error, setError] = useState(false)

  const handleDelete = () => {
    deleteAccount()
    console.log("Account deleted")
    close()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim(); 

    setInput(value)
    if (value !== "DELETE" || value.length === 0) {
        setError(true)
        return
      }
      if (value === "DELETE") {
        setError(false)
      }
        
  }

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent className="max-w-[480px] rounded-xl p-6 text-center space-y-5 [&>button]:hidden">
        <div className="flex justify-between items-start w-full">
          <div />
          <button onClick={close} className="absolute right-4 top-4 size-8 rounded-full flex justify-center items-center bg-[#0404040D] text-center text-gray-400 hover:bg-[#0404040D] hover:text-gray-600 !mt-0">
            <X className="h-5 w-5 text-gray-500 m-0" />
          </button>
        </div>

        <DialogHeader>
          <DialogTitle className="text-3xl text-center text-[#2D2F35] font-medium my-4">Warning: This action is irreversible</DialogTitle>
          <DialogDescription className=" text-center text-[#2D2F35] mt-2 text-base">
            All your data including weight logs, progress, medical records, and personal information will be permanently deleted.
          </DialogDescription>
        </DialogHeader>

        <div className="text-left space-y-2 w-full">
          <label htmlFor="delete-confirm" className="text-sm font-medium text-[#1A202C]">
            Type <span className="font-semibold">DELETE</span> to confirm:
          </label>
          <Input
            id="delete-confirm"
            value={input}
            onChange={handleChange}
            className={cn("w-full", error && "border-[#FF3B3B] text-[#FF3B3B] bg-[#FFEBEB] p-3")}
          />
          {error && (
            <div className="text-red-500 text-xs flex items-center gap-1 mt-1">
              <AlertCircle size={16} />
              Invalid input
            </div>
          )}
        </div>

        <div className="flex justify-center gap-4 mt-4">
          <Button variant="outline" onClick={close} className="w-full bg-blue-600 text-white hover:text-white hover:bg-blue-700 border-none px-3 py-5 rounded-lg">
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            className="w-full border border-[#FF3B3B] text-[text-[#FF3B3B] hover:text-[#FF3B3B] text-[#FF3B3B] hover:bg-red-100 px-3 py-5 rounded-lg"
            variant="outline"
            disabled={input !== "DELETE"}
          >
            Confirm delete
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
